<section class="indice-form">
  <div class="container">
    @for(numeroPasso of arrayPassos;track numeroPasso) {
      <a href="javascript:void(0)" class="icon-indice" [ngClass]="{'ativo' :passoAtual >= numeroPasso   }"><span></span></a>

    }
  </div>
</section>
